import * as React from 'react';

function ErrorMessage({ text }: { text: string }) {
  return (
    <>
      <h2>Unknown error occurred</h2>
      <pre>
        <code>{text}</code>
      </pre>
    </>
  );
}

const errorMessageRenderer = (error: Error | undefined) => {
  const stringified = JSON.stringify(error, Object.getOwnPropertyNames(error), 2);

  return <ErrorMessage text={stringified} />;
};

export { errorMessageRenderer };
